import { type ReactElement } from 'react';
import { type WorkLineView } from '@vello/api-client';
import { Badge, Cluster, Text } from '@vello/web-theme';
import { useT } from '../i18n/provider';
import { useVocab } from '../i18n/vocab';

/**
 * What a partner works in (D621) as chips — "Carro", "Mototáxi", "Comida", "Encomendas" — named by the central vocabulary
 * (`driver.work_line`), never a raw code. An empty list reads "Nada habilitado ainda", never a blank cell.
 */
export function WorkLineChips({ lines }: { readonly lines: readonly WorkLineView[] | undefined }): ReactElement {
  const { t } = useT();
  const { v } = useVocab();
  if (lines === undefined || lines.length === 0) return <Text role="caption" tone="tertiary">{t('worklines.none')}</Text>;
  return (
    <Cluster gap={1} wrap data-testid="work-lines">
      {lines.map((l) => <Badge key={l}>{v('driver.work_line', l)}</Badge>)}
    </Cluster>
  );
}
